import { BASEURL } from "../BaseUrl";

/**
 * Fetches a list of sql queries with optional filters and pagination.
 * @param {Object} axios - The Axios instance to use for the request.
 */
const getAllSqlQueries = async (axios, data) => {
  return await axios.get(`${BASEURL}/sql/get-query`, {});
};

export const PowerBiApi = {
    getAllSqlQueries,
};
